import { render } from "./facility-actions.vue?vue&type=template&id=0b598f20&scoped=true"
import script from "./facility-actions.vue?vue&type=script&lang=js"
export * from "./facility-actions.vue?vue&type=script&lang=js"

import "./facility-actions.vue?vue&type=style&index=0&id=0b598f20&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b598f20"]])

export default __exports__